/**
 * @generated SignedSource<<bf53b31200faa03d71becb38cd3f08cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutWireTransferWrapper_buyer$data = {
  readonly addressBook: {
    readonly addressList: ReadonlyArray<{
      readonly company: string | null;
      readonly displayCountry: string | null;
      readonly displayName: string | null;
      readonly formattedAddress: ReadonlyArray<string | null> | null;
      readonly phoneNumber: string | null;
      readonly serviceId: string | null;
    } | null> | null;
  } | null;
  readonly isVerifiedTrade: boolean | null;
  readonly isVip: boolean | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutWireTransferForm_buyer">;
  readonly " $fragmentType": "CheckoutWireTransferWrapper_buyer";
};
export type CheckoutWireTransferWrapper_buyer$key = {
  readonly " $data"?: CheckoutWireTransferWrapper_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutWireTransferWrapper_buyer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutWireTransferWrapper_buyer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVip",
      "storageKey": null
    },
    {
      "alias": "isVerifiedTrade",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "B_NET_PRICE"
        }
      ],
      "kind": "ScalarField",
      "name": "hasPermission",
      "storageKey": "hasPermission(name:\"B_NET_PRICE\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AddressBook",
      "kind": "LinkedField",
      "name": "addressBook",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "addressList",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "company",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "formattedAddress",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayCountry",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "phoneNumber",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutWireTransferForm_buyer"
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "fad2309e713ff52118c8b518dc71711f";

export default node;
